import React from 'react'
import PropTypes from 'prop-types'
import { Badge, useTheme } from '@mui/material'
import { styled } from '@mui/system'
import { PickersDay } from '@mui/x-date-pickers'

const StyledBadge = styled(Badge)(({ theme, badgecolor }) => ({
  '& .MuiBadge-badge': {
    right: 3,
    top: 13,
    border: `2px solid ${(theme.vars ?? theme).palette.background.paper}`,
    padding: '0 4px',
    backgroundColor: badgecolor || theme.palette.primary.main,
    color: badgecolor === theme.palette.grey[300] ? theme.palette.common.white : theme.palette.primary.contrastText,
  },
}))

function EventDay(props) {
  const theme = useTheme()
  const { eventsByDay = {}, eventStatusesByDay = {}, day, outsideCurrentMonth, ...other } = props

  const dayNum = day.getDate()

  const eventsForDay = eventsByDay[dayNum] || []
  const eventCount = eventsForDay.length
  const dayStatus = eventStatusesByDay[dayNum]

  const showBadge = !outsideCurrentMonth && eventCount > 0

  // Determine badge color based on event status
  let badgeColor = theme.palette.primary.main // Default blue for 'existing'

  if (dayStatus === 'new') {
    badgeColor = theme.palette.info.light // Light blue for new events
  } else if (dayStatus === 'removed') {
    badgeColor = theme.palette.grey[300] // Grey for removed events
  } else if (dayStatus === 'existing') {
    badgeColor = theme.palette.primary.main // Blue for existing events
  }

  return (
    <StyledBadge
      key={day.toString()}
      overlap="circular"
      badgeContent={showBadge ? eventCount : undefined}
      color="primary"
      badgecolor={badgeColor}
      sx={{ zIndex: theme.zIndex.appBar + 1 }}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
    </StyledBadge>
  )
}

EventDay.propTypes = {
  eventsByDay: PropTypes.object,
  eventStatusesByDay: PropTypes.object,
  day: PropTypes.object,
  outsideCurrentMonth: PropTypes.bool,
}

export default EventDay
